<template>
  <zingchart :data="chartConfig" :width="800" />
</template>

<script>
  export default {
    data() {
      return {
        chartConfig: {
          graphset: [{
            type: 'bar',
            title: {
              text: 'GMV по месяцам в разрезе терминалов',
              align: 'left',
              marginLeft: '23%'
            },
            legend: {
              adjustLayout: true,
              verticalAlign: 'middle'
            },
            scaleX: {
              values: ['«ЗТК Тамань» ООО', 'ООО «НЗТ»', 'ПАО «НКХП»']
            },
            series: [{
              values: [null, 7088.40, 6190.30],
              text: '3'
            }, {
              values: [null, 373.45, 4218.80],
              text: '4'
            }, {
              values: [50.52, 54478.80, 4099.52],
              text: '7'
            }, {
              values: [281.87, 21625.30, 18475.50],
              text: '8'
            }, {
              values: [10338.50, 14635.65, 12259.24],
              text: '9'
            }, {
              values: [14357.82, 41879.03, 24613.60],
              text: '10'
            }, {
              values: [null, 57155.80, 29941.62],
              text: '11'
            }, {
              values: [17519.29, 30044.05, 6998.08],
              text: '12'
            }]
          }]
        }
      }
    }
  }
</script>

<style scoped>

</style>